import Router from 'next/router';
import styles from './ImageWithTextCard.module.scss';
import Image from 'next/image';
import { Typography } from '@mui/material';
import { useRef, useState } from 'react';

import imgLoader from '../../../../../imgloader';

const ImageWithTextCard = ({
  title = '',
  image = '',
  description = '',
  url = '/',
  className = '',
  ...rest
}) => {
  const [maxWidth, setmaxWidth] = useState('auto');
  return (
    <div className={`${styles.productCardContainer} ${className}`} {...rest}>
      <div className={`${styles.productImageContainer}`}>
        <div>
          <div className={styles.productImgContainer}>
            <Image
              alt={'Relief Factor Pain Relief'}
              layout="fill"
              src={image}
              loading="eager"
              objectFit="contain"
              loader={imgLoader}
              className={styles.productImg}
            />
          </div>
        </div>
      </div>
      <div className={styles.blurContainer}></div>
      <div className={styles.descriptionContainer}>
        <Typography variant="h4">{title}</Typography>
        <Typography variant="p1" className={styles.description}>
          {description}
        </Typography>
      </div>
    </div>
  );
};

export default ImageWithTextCard;
